import { render, staticRenderFns } from "./report-fangan.vue?vue&type=template&id=ea4f9c64&scoped=true&"
import script from "./report-fangan.vue?vue&type=script&lang=ts&"
export * from "./report-fangan.vue?vue&type=script&lang=ts&"
import style0 from "./report-fangan.vue?vue&type=style&index=0&id=ea4f9c64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4f9c64",
  null
  
)

export default component.exports